import * as RadixAlertDialog from '@radix-ui/react-alert-dialog';
import { ReactNode } from 'react';
import './Dialog.css';

export const Dialog = ({
  open,
  setOpen,
  title,
  description,
  triggerElement,
  cancelElement,
  actionElement,
  children,
}: {
  open?: boolean;
  setOpen?: (value: boolean) => void;
  title?: string;
  description?: string;
  triggerElement?: ReactNode;
  cancelElement?: ReactNode;
  actionElement?: ReactNode;
  children?: ReactNode;
}) => (
  <RadixAlertDialog.Root open={open} onOpenChange={setOpen}>
    {triggerElement && (
      <RadixAlertDialog.Trigger asChild>
        {triggerElement}
      </RadixAlertDialog.Trigger>
    )}
    <RadixAlertDialog.Portal>
      <RadixAlertDialog.Overlay
        className="AlertDialogOverlay"
        onClick={() => setOpen && setOpen(false)}
      />
      <RadixAlertDialog.Content className="AlertDialogBody">
        <div className="AlertDialogBodyHeader">
          <RadixAlertDialog.Title className="AlertDialogTitle">
            {title}
          </RadixAlertDialog.Title>
          <RadixAlertDialog.Description className="AlertDialogDescription">
            {description}
          </RadixAlertDialog.Description>
        </div>

        <div className="AlertDialogContent">{children}</div>

        <div className="AlertDialogBodyFooter">
          <div style={{ display: 'flex', gap: 25, justifyContent: 'flex-end' }}>
            <RadixAlertDialog.Cancel asChild>
              <button>{cancelElement}</button>
            </RadixAlertDialog.Cancel>
            <RadixAlertDialog.Action asChild>
              <button>{actionElement}</button>
            </RadixAlertDialog.Action>
          </div>
        </div>
      </RadixAlertDialog.Content>
    </RadixAlertDialog.Portal>
  </RadixAlertDialog.Root>
);
